// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style__extensionContainer___aWudC {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgb(240,240,240);
    border-radius: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/components/FileLabel/style.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kCAAkC;IAClC,kBAAkB;AACtB","sourcesContent":[".extensionContainer {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: rgb(240,240,240);\n    border-radius: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"extensionContainer": `style__extensionContainer___aWudC`
};
export default ___CSS_LOADER_EXPORT___;
